import { ReactNode, useContext } from "react"
import { AppActionContext } from "../AppState.ts"
import { HStack, Spacer } from "../UI.tsx"

export function TimelineControls(props: {
  canGoToPriorKeyframe: boolean,
  canGoToNextKeyframe: boolean,
  isPlaying: boolean,
  canDeleteKeyframe: boolean,
}): ReactNode {
  const { canGoToPriorKeyframe, canGoToNextKeyframe, isPlaying, canDeleteKeyframe } = props

  const sendAppAction = useContext(AppActionContext)

  return <HStack>

    {/* For symmetry */}
    <div></div>
    <button disabled={true} style={{
      fontSize: '30px',
      visibility: 'hidden',
    }}>
      🗑️
    </button>

    <Spacer />

    <button
      onClick={() => sendAppAction({ type: 'goToPriorKeyframe' })}
      title={'Go to prior keyframe' + (canGoToPriorKeyframe ? '' : '\n(At first keyframe)')}
      disabled={!canGoToPriorKeyframe}
      style={{
        fontSize: '30px',
      }}
    >
      ⏮
    </button>
    <button
      onClick={() => sendAppAction({ type: 'togglePlayPause' })}
      style={{
        fontSize: '30px',
      }}
    >
      {isPlaying ? '⏸' : '⏵'}
    </button>
    <button
      onClick={() => sendAppAction({ type: 'goToNextKeyframe' })}
      title={'Go to next keyframe' + (canGoToNextKeyframe ? '' : '\n(At last keyframe)')}
      disabled={!canGoToNextKeyframe}
      style={{
        fontSize: '30px',
      }}
    >
      ⏭
    </button>

    <Spacer />

    <button
      onClick={() => sendAppAction({ type: 'extendTimeline', seconds: 1 })}
      title='Extend timeline by 1 second'
      style={{
        fontSize: '30px',
      }}
    >
      ➕⏱️
    </button>

    <button
      onClick={() => sendAppAction({ type: 'deleteCurrentKeyframe' })}
      disabled={!canDeleteKeyframe}
      title={'Delete current keyframe' + (canDeleteKeyframe ? '' : '\n(Not on a keyframe)')}
      style={{
        fontSize: '30px',
      }}
    >
      🗑️
    </button>

    <div></div>
  </HStack>
}
